import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, AlertTriangleIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-20 bg-gray-50 px-4" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border-t-4 border-brandOrange-500 relative" data-id="element-132">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-navy-900 text-white px-6 py-2 rounded-full flex items-center gap-2 font-bold shadow-lg" data-id="element-133">
            <MoonIcon className="w-5 h-5 text-brandOrange-500" data-id="element-134" />
            <span data-id="element-135">Son las 11:30 PM...</span>
          </div>

          <div className="mt-6 text-center space-y-6" data-id="element-136">
            <p className="text-xl md:text-2xl text-gray-800 font-medium leading-relaxed" data-id="element-137">
              Tienes 15 pestañas abiertas, un curso de 20 horas sin terminar y
              la sensación frustrante de que, aunque trabajas mucho, tu tienda
              sigue{' '}
              <span className="font-bold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-138">
                "en construcción"
              </span>
              .
            </p>

            <div className="w-24 h-1 bg-gray-200 mx-auto my-8" data-id="element-139"></div>

            <div className="bg-navy-50 p-6 rounded-xl border border-navy-100 flex gap-4 items-start text-left" data-id="element-140">
              <AlertTriangleIcon className="w-8 h-8 text-brandOrange-500 flex-shrink-0 mt-1" data-id="element-141" />
              <div data-id="element-142">
                <h3 className="text-xl font-bold text-navy-900 mb-2 normal-case" data-id="element-143">
                  El perfeccionismo es la forma más cara de procrastinación.
                </h3>
                <p className="text-gray-700 text-lg" data-id="element-144">
                  Mientras esperas a que el logo sea perfecto o a entender cada
                  detalle técnico, alguien con menos conocimiento pero más
                  velocidad está haciendo las ventas que te pertenecen a ti.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}